import apiAction from 'common/redux/actions/apiAction';
import { POST_ADMINVIEW_COMPLIANCE_PROFILE_STATUS_URL } from './apiPathConstants';
import { logError } from 'TAP/utils/commonMethods';

const getAdminComplianceData = data => {
  return {
    type: 'GET_ADMIN_COMPLIANCE_DATA',
    payload: data,
  };
};

export const AdminComplianceData = configParams => {
  return apiAction.postAPI({
    url: POST_ADMINVIEW_COMPLIANCE_PROFILE_STATUS_URL(),
    data: configParams,
    onSuccess: getAdminComplianceData,
    onFailure: err => logError('Error occured in fetching My Org Compliance data:', err),
    label: 'FETCH_ADMIN_COMPLIANCE_DATA',
  });
};
